module.exports = __webpack_public_path__ + "img/404-2.7d176dce.gif";